var React = require('react');

function Login (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)"},[React.createElement("path",{"fill":"#F6F6F9","d":"M10 13.834a4.215 4.215 0 0 1-2.077-.56C5.737 13.41 4 15.15 4 17.278v.992l.417.13c.08.023 2.006.6 5.583.6 3.577 0 5.502-.577 5.583-.6l.417-.13v-.992c0-2.127-1.737-3.869-3.924-4.006a4.209 4.209 0 0 1-2.076.562zm3.6-5.31C13.6 6.582 11.985 5 10 5 8.016 5 6.4 6.58 6.4 8.525c0 1.9 1.572 4.111 3.6 4.111 2.028.001 3.6-2.21 3.6-4.111z","key":0}),React.createElement("circle",{"cx":"10","cy":"10","r":"10","stroke":"#F6F6F9","strokeWidth":"2","key":1})]));
}

Login.defaultProps = {"className":"login","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Login;

Login.default = Login;
